// CDN-based icon URLs for all supported services
// Uses devicon (https://devicon.dev) and simpleicons where devicon doesn't have coverage

const DEVICON_BASE =
  "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons";
const SIMPLEICONS_BASE = "https://cdn.simpleicons.org";

interface ServiceIconConfig {
  iconUrl: string;
  color: string;
  bgTint: string;
}

// Map service names (lowercase) to their icon config
const SERVICE_ICON_MAP: Record<string, ServiceIconConfig> = {
  // Databases
  postgres: {
    iconUrl: `${DEVICON_BASE}/postgresql/postgresql-original.svg`,
    color: "#336791",
    bgTint: "#eff6ff",
  },
  postgresql: {
    iconUrl: `${DEVICON_BASE}/postgresql/postgresql-original.svg`,
    color: "#336791",
    bgTint: "#eff6ff",
  },
  mysql: {
    iconUrl: `${DEVICON_BASE}/mysql/mysql-original.svg`,
    color: "#4479A1",
    bgTint: "#eff6ff",
  },
  mariadb: {
    iconUrl: `${SIMPLEICONS_BASE}/mariadb/003545`,
    color: "#003545",
    bgTint: "#ecfeff",
  },
  mongodb: {
    iconUrl: `${DEVICON_BASE}/mongodb/mongodb-original.svg`,
    color: "#47A248",
    bgTint: "#f0fdf4",
  },
  mongo: {
    iconUrl: `${DEVICON_BASE}/mongodb/mongodb-original.svg`,
    color: "#47A248",
    bgTint: "#f0fdf4",
  },
  redis: {
    iconUrl: `${DEVICON_BASE}/redis/redis-original.svg`,
    color: "#DC382D",
    bgTint: "#fef2f2",
  },
  elasticsearch: {
    iconUrl: `${DEVICON_BASE}/elasticsearch/elasticsearch-original.svg`,
    color: "#005571",
    bgTint: "#ecfeff",
  },
  opensearch: {
    iconUrl: `${SIMPLEICONS_BASE}/opensearch/005EB8`,
    color: "#005EB8",
    bgTint: "#eff6ff",
  },
  clickhouse: {
    iconUrl: `${SIMPLEICONS_BASE}/clickhouse/FFCC01`,
    color: "#FFCC01",
    bgTint: "#fefce8",
  },
  influxdb: {
    iconUrl: `${SIMPLEICONS_BASE}/influxdb/22ADF6`,
    color: "#22ADF6",
    bgTint: "#ecfeff",
  },
  timescaledb: {
    iconUrl: `${SIMPLEICONS_BASE}/timescale/FDB515`,
    color: "#FDB515",
    bgTint: "#fefce8",
  },
  // Cache / Message Brokers
  rabbitmq: {
    iconUrl: `${SIMPLEICONS_BASE}/rabbitmq/FF6600`,
    color: "#FF6600",
    bgTint: "#fff7ed",
  },
  nats: {
    iconUrl: `${SIMPLEICONS_BASE}/nats.io/27AAE1`,
    color: "#27AAE1",
    bgTint: "#ecfeff",
  },
  mosquitto: {
    iconUrl: `${SIMPLEICONS_BASE}/eclipsemosquitto/3C5280`,
    color: "#3C5280",
    bgTint: "#eff6ff",
  },
  etcd: {
    iconUrl: `${SIMPLEICONS_BASE}/etcd/419EDA`,
    color: "#419EDA",
    bgTint: "#eff6ff",
  },
  // Monitoring & Observability
  grafana: {
    iconUrl: `${DEVICON_BASE}/grafana/grafana-original.svg`,
    color: "#F46800",
    bgTint: "#fff7ed",
  },
  prometheus: {
    iconUrl: `${DEVICON_BASE}/prometheus/prometheus-original.svg`,
    color: "#E6522C",
    bgTint: "#fef2f2",
  },
  alertmanager: {
    iconUrl: `${DEVICON_BASE}/prometheus/prometheus-original.svg`,
    color: "#E6522C",
    bgTint: "#fef2f2",
  },
  victoriametrics: {
    iconUrl: `${SIMPLEICONS_BASE}/victoriametrics/621773`,
    color: "#621773",
    bgTint: "#fdf4ff",
  },
  graylog: {
    iconUrl: `${SIMPLEICONS_BASE}/graylog/FF3633`,
    color: "#FF3633",
    bgTint: "#fef2f2",
  },
  elk: {
    iconUrl: `${SIMPLEICONS_BASE}/elasticstack/005571`,
    color: "#005571",
    bgTint: "#ecfeff",
  },
  // CI/CD & DevOps
  jenkins: {
    iconUrl: `${DEVICON_BASE}/jenkins/jenkins-original.svg`,
    color: "#D24939",
    bgTint: "#fef2f2",
  },
  gitea: {
    iconUrl: `${SIMPLEICONS_BASE}/gitea/609926`,
    color: "#609926",
    bgTint: "#f0fdf4",
  },
  sonarqube: {
    iconUrl: `${SIMPLEICONS_BASE}/sonarqube/4E9BCD`,
    color: "#4E9BCD",
    bgTint: "#eff6ff",
  },
  nexus: {
    iconUrl: `${SIMPLEICONS_BASE}/sonatype/1B1C30`,
    color: "#1B1C30",
    bgTint: "#f3f4f6",
  },
  // Infrastructure
  nginx: {
    iconUrl: `${DEVICON_BASE}/nginx/nginx-original.svg`,
    color: "#009639",
    bgTint: "#f0fdf4",
  },
  portainer: {
    iconUrl: `${SIMPLEICONS_BASE}/portainer/13BEF9`,
    color: "#13BEF9",
    bgTint: "#ecfeff",
  },
  minio: {
    iconUrl: `${SIMPLEICONS_BASE}/minio/C72C48`,
    color: "#C72C48",
    bgTint: "#fef2f2",
  },
  kong: {
    iconUrl: `${SIMPLEICONS_BASE}/kong/003459`,
    color: "#003459",
    bgTint: "#eff6ff",
  },
  // Container Registry
  dockerregistry: {
    iconUrl: `${DEVICON_BASE}/docker/docker-original.svg`,
    color: "#2496ED",
    bgTint: "#eff6ff",
  },
  docker_registry: {
    iconUrl: `${DEVICON_BASE}/docker/docker-original.svg`,
    color: "#2496ED",
    bgTint: "#eff6ff",
  },
  // Business / Analytics
  metabase: {
    iconUrl: `${SIMPLEICONS_BASE}/metabase/509EE3`,
    color: "#509EE3",
    bgTint: "#eff6ff",
  },
  redash: {
    iconUrl: `${SIMPLEICONS_BASE}/redash/FF6F61`,
    color: "#FF6F61",
    bgTint: "#fef2f2",
  },
  lightdash: {
    iconUrl: `${SIMPLEICONS_BASE}/lightning/7B68EE`,
    color: "#7B68EE",
    bgTint: "#f5f3ff",
  },
  // Project Management / Wikis
  redmine: {
    iconUrl: `${SIMPLEICONS_BASE}/redmine/B32024`,
    color: "#B32024",
    bgTint: "#fef2f2",
  },
  bookstack: {
    iconUrl: `${SIMPLEICONS_BASE}/bookstack/0288D1`,
    color: "#0288D1",
    bgTint: "#eff6ff",
  },
  wikijs: {
    iconUrl: `${SIMPLEICONS_BASE}/wikidotjs/1976D2`,
    color: "#1976D2",
    bgTint: "#eff6ff",
  },
  nextcloud: {
    iconUrl: `${SIMPLEICONS_BASE}/nextcloud/0082C9`,
    color: "#0082C9",
    bgTint: "#eff6ff",
  },
  taiga: {
    iconUrl: `${SIMPLEICONS_BASE}/taiga/4C566A`,
    color: "#4C566A",
    bgTint: "#f3f4f6",
  },
  kanboard: {
    iconUrl: `${SIMPLEICONS_BASE}/kanboard/2FA0ED`,
    color: "#2FA0ED",
    bgTint: "#eff6ff",
  },
  unleash: {
    iconUrl: `${SIMPLEICONS_BASE}/unleash/1A4049`,
    color: "#1A4049",
    bgTint: "#f3f4f6",
  },
  sentry: {
    iconUrl: `${SIMPLEICONS_BASE}/sentry/362D59`,
    color: "#362D59",
    bgTint: "#f5f3ff",
  },
  // Database Tools
  adminer: {
    iconUrl: `${DEVICON_BASE}/postgresql/postgresql-original.svg`,
    color: "#336791",
    bgTint: "#eff6ff",
  },
  pgadmin: {
    iconUrl: `${DEVICON_BASE}/postgresql/postgresql-original.svg`,
    color: "#336791",
    bgTint: "#eff6ff",
  },
  meilisearch: {
    iconUrl: `${SIMPLEICONS_BASE}/meilisearch/FF5CAA`,
    color: "#FF5CAA",
    bgTint: "#fdf2f8",
  },
  chartmuseum: {
    iconUrl: `${DEVICON_BASE}/helm/helm-original.svg`,
    color: "#0F1689",
    bgTint: "#eff6ff",
  },
};

// Default config for unknown services
const DEFAULT_CONFIG: ServiceIconConfig = {
  iconUrl: "",
  color: "#6b7280",
  bgTint: "#f3f4f6",
};

/**
 * Get icon configuration for a service by name.
 * Falls back to a default gray icon if the service is not recognized.
 */
export function getServiceIcon(serviceName: string): ServiceIconConfig {
  const key = serviceName.toLowerCase().replace(/[\s_-]+/g, "");
  return SERVICE_ICON_MAP[key] || DEFAULT_CONFIG;
}

/**
 * Get the short label for a service (used as fallback when icon fails to load)
 */
export function getServiceLabel(serviceName: string): string {
  const name = serviceName.toLowerCase();
  if (name.includes("postgres") || name === "pgadmin") return "PG";
  if (name.includes("mysql")) return "MY";
  if (name.includes("maria")) return "MA";
  if (name.includes("mongo")) return "MO";
  if (name.includes("redis")) return "RE";
  if (name.includes("elastic")) return "ES";
  if (name.includes("opensearch")) return "OS";
  if (name.includes("clickhouse")) return "CH";
  if (name.includes("influx")) return "IF";
  if (name.includes("timescale")) return "TS";
  if (name.includes("rabbit")) return "RQ";
  if (name.includes("nats")) return "NT";
  if (name.includes("mosquitto")) return "MQ";
  if (name.includes("grafana")) return "GF";
  if (name.includes("prometheus") || name.includes("alertmanager")) return "PM";
  if (name.includes("victoria")) return "VM";
  if (name.includes("graylog")) return "GL";
  if (name.includes("elk")) return "ELK";
  if (name.includes("jenkins")) return "JK";
  if (name.includes("gitea")) return "GT";
  if (name.includes("sonar")) return "SQ";
  if (name.includes("nexus")) return "NX";
  if (name.includes("nginx")) return "NG";
  if (name.includes("portainer")) return "PT";
  if (name.includes("minio")) return "MN";
  if (name.includes("kong")) return "KG";
  if (name.includes("docker") || name.includes("registry")) return "DR";
  if (name.includes("metabase")) return "MB";
  if (name.includes("redash")) return "RD";
  if (name.includes("lightdash")) return "LD";
  if (name.includes("redmine")) return "RM";
  if (name.includes("bookstack")) return "BS";
  if (name.includes("wiki")) return "WK";
  if (name.includes("nextcloud")) return "NC";
  if (name.includes("taiga")) return "TG";
  if (name.includes("kanboard")) return "KB";
  if (name.includes("unleash")) return "UL";
  if (name.includes("sentry")) return "SN";
  if (name.includes("adminer")) return "AD";
  if (name.includes("meilisearch")) return "MS";
  if (name.includes("chart")) return "CM";
  if (name.includes("etcd")) return "ET";
  return serviceName.substring(0, 2).toUpperCase();
}
